<template>
  <div class="app-container">
    <el-alert
      title="配置学员端展示的难度档名，保存后在学员下次加载时生效。展示档位不改变评分难度和难度得分。"
      type="info"
      :closable="false"
      class="mb10"
    />
    <el-card class="box-card" v-loading="loading">
      <el-table :data="list" border>
        <el-table-column prop="id" label="ID" width="70" />
        <el-table-column label="百分比区间" width="280">
          <template slot-scope="{row}">
            <el-input-number v-model="row.percentFrom" :min="0" :max="100" size="small" controls-position="right" style="width:120px" />
            ~
            <el-input-number v-model="row.percentTo" :min="0" :max="100" size="small" controls-position="right" style="width:120px" />
          </template>
        </el-table-column>
        <el-table-column label="显示名称" min-width="200">
          <template slot-scope="{row}">
            <el-input v-model="row.displayName" maxlength="10" show-word-limit size="small" />
          </template>
        </el-table-column>
        <el-table-column label="排序" width="120">
          <template slot-scope="{row}">
            <el-input-number v-model="row.sort" :min="0" size="small" controls-position="right" style="width:100%;display:block" />
          </template>
        </el-table-column>
      </el-table>
      <div class="mt10 save-bar">
        <el-button type="primary" :loading="saving" @click="handleSave" v-hasPermi="['aiTrain:tier:edit']">保存</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>
import { listRows } from '@/utils/ai-train-data'
import aiTrainTierApi from '@/api/aiTrain/tier'

export default {
  name: 'AiTrainTier',
  data() {
    return {
      loading: false,
      saving: false,
      list: []
    }
  },
  created() {
    this.loadList()
  },
  methods: {
    loadList() {
      this.loading = true
      aiTrainTierApi.fetchList()
        .then(res => {
          const data = (res && res.data) || res || []
          this.list = listRows(data)
        })
        .catch(() => { this.list = [] })
        .finally(() => { this.loading = false })
    },
    handleSave() {
      if (this.list.some(r => !r.displayName)) {
        this.$message.error('存在未填写档名的行')
        return
      }
      this.saving = true
      aiTrainTierApi.update(this.list)
        .then(() => { this.$message.success('保存成功，学员下次加载时生效') })
        .catch(() => {}).finally(() => { this.saving = false })
    }
  }
}
</script>

<style scoped>
.mb10 { margin-bottom: 10px; }
.mt10 { margin-top: 10px; }
.save-bar { text-align: right; }
</style>
